import * as actions from "./propertyAmenity.actions";
import * as api from "./propertyAmenity.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY, } from "./propertyAmenity.constants";
import * as hooks from "./propertyAmenity.hooks";
import * as promises from "./propertyAmenity.promises";
import reducer from "./propertyAmenity.reducer";
import { saga } from "./propertyAmenity.saga";
import * as selectors from "./propertyAmenity.selectors";
export * from "./propertyAmenity.types";
export var REDUCER_KEY_PROPERTY_AMENITY = REDUCER_KEY;
export var propertyAmenityModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
};
